var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',_vm._l((_vm.filter(_vm.tags)),function(tag){return _c('a',{key:tag,class:{select: _vm.select == tag },attrs:{"id":_vm.tagID(tag)},domProps:{"innerHTML":_vm._s(tag)},on:{"click":function($event){return _vm.$emit('selectTag', tag)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }